import React from "react";

const Disclaimer = ({ darkTheme }) => {
  return (
    <div
      id="disclaimer"
      className="modal fade"
      role="dialog"
      aria-hidden="true"
    >
      <div
        className="modal-dialog modal-lg modal-dialog-centered"
        role="document"
      >
        <div
          className={
            "modal-content " + (darkTheme ? "bg-dark-2 text-light" : "")
          }
        >
          <div className="modal-header">
            <h5 className={"modal-title " + (darkTheme ? "text-white" : "")}>
              Copyright &amp; Disclaimer
            </h5>
            <button
              type="button"
              className={"btn-close " + (darkTheme ? "btn-close-white" : "")}
              data-bs-dismiss="modal"
              aria-label="Close"
            />
          </div>
          <div className="modal-body p-4">
            <p>
              The information provided on Ya Yan Kwan's Resume Website is for
              general informational purposes only. All information on the site
              is provided in good faith, however, we make no representation or
              warranty of any kind, express or implied, regarding the accuracy,
              adequacy, validity, reliability, availability, or completeness of
              any information on the site.
            </p>
            <ul className="lh-lg">
              <li>
                Under no circumstance shall we have any liability to you for any
                loss or damage of any kind incurred as a result of the use of
                the site or reliance on any information provided on the site.
                Your use of the site and your reliance on any information on the
                site is solely at your own risk.
              </li>
              <li>
                This website may contain links to other websites or content
                belonging to or originating from third parties or links to
                websites and features in banners or other advertising. Such
                external links are not investigated, monitored, or checked for
                accuracy, adequacy, validity, reliability, availability, or
                completeness by us.
              </li>
              <li>
                We do not warrant, endorse, guarantee, or assume responsibility
                for the accuracy or reliability of any information offered by
                third-party websites linked through the site or any website or
                feature linked in any banner or other advertising.
              </li>
              <li>
                The site cannot and does not contain specific advice. The
                information is provided for general informational and
                educational purposes only and is not a substitute for
                professional advice.
              </li>
              <li>
                Accordingly, before taking any actions based upon such
                information, we encourage you to consult with the appropriate
                professionals.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Disclaimer;
